import React, { Component } from "react";
import { Grid, List, ListItem, Typography } from '@material-ui/core';
import * as QueryString from "query-string";
import Header from "../../components/Header";
import { primaryColor, textBlack, textPrimary, webFont } from '../../config/theme';
import { BOOKING_STATUS } from "../../config/constants";
import Button from "@material-ui/core/Button/Button";
import BookingList from "../../components/ChefBooking/BookingList";
import BookingCard from "../../components/ChefBooking/BookingCard";
import LinearProgress from "@material-ui/core/LinearProgress";
import { client } from "../../config/apollo";
import { USER_BOOKINGS } from "../../graphql/queries/bookings";
import {DISHES_BY_CHEF} from '../../graphql/queries/dishes';
import connect from "react-redux/es/connect/connect";
import { setCurrentBooking } from "../../redux/chefs";
import InProgressBooking from "../../components/Booking/InProgressBooking";
import {
  setExBooking,
  CreateInProgressBooking,
  selectedChef,
  SelectedChefAvailability,
  SelectedChefDetails,
  setSelectedDate,
  setSelectedSlot,
  updateCart,
  setPendingBooking, pendingBooking, setCustomPriceange
} from '../../redux/bookings';
import { UPDATE_BOOKING } from "../../graphql/mutations/booking";
import {compose, graphql} from "react-apollo";
import moment from 'moment';
import Breadcrumbs from "../../components/Breadcrumbs";


class Bookings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [
        {
          header: "STEP 2",
          text: "Saved for later",
          id: 3,
          status: [BOOKING_STATUS.INCOMPLETE]
        },
        {
          header: "STEP 1",
          text: "Current",
          id: 1,
          status: [BOOKING_STATUS.PENDING,BOOKING_STATUS.ACCEPTED]
        },
        {
          header: "STEP 3",
          text: "Past",
          id: 2,
          status: [BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF, BOOKING_STATUS.CANCELED_APPROVED_BY_DINER, BOOKING_STATUS.COMPLETED,BOOKING_STATUS.REJECTED,BOOKING_STATUS.CANCELED,BOOKING_STATUS.COMPLETED_BY_CHEF,BOOKING_STATUS.COMPLETED_BY_USER,BOOKING_STATUS.EXPIRED, BOOKING_STATUS.CANCELED_BY_DINER]
        },
      ],
      step: 1,
      bookings: [],
      loading: false,
      bookingDrawer: false,
      stepIdHover: 0,
      isRecurring: false,
      isCustom: false,
    };
  }

  fetchBookings = status => {
    const { userId } = this.props;
    this.setState({loading: true });
    let bookingArr=[];
      !!status.length && status.map(status =>(
          client
              .query({
                  query: USER_BOOKINGS,
                  variables: {
                    userId,
                    status,
                    pageSize: 100
                  },
                  fetchPolicy: "network-only"
              })
              .then(resp => {
                  if (resp.data) {
                      if (resp.data.userBookings) {
                          const {
                              userBookings: { bookings }
                          } = resp.data;
                          bookingArr=bookingArr.concat(bookings);
                          this.setState({
                              bookings:bookingArr,
                              loading: false
                          });
                      }
                  }
              })
              .catch(err => {
                  this.setState({ loading: false });
                  console.log(JSON.parse(JSON.stringify(err)));
              })
      ))

  };

  setStepIdHover = stepId => {
    this.setState({ stepIdHover: stepId });
  };

  static getDerivedStatefromProps(props, state) {
    const { location } = props;
    const parsed = QueryString.parse(location.search);

    if (parsed) {
      const step = parsed.step ? parseInt(parsed.step) : 1;

      if (step === 1) {
        return {
          bookingDrawer: false,
        };
      }
    }
    return null;
  }

  fetchDetailsOnLoad = () => {
    const { location, dispatch } = this.props;
    const parsed = QueryString.parse(location.search);

    if (parsed) {
      const step = parsed.step ? parseInt(parsed.step) : 1;

      this.setState({ step });
      if (parsed.closeSlider) {
        this.setState({ bookingDrawer: false });
        const stepDetails = this.state.steps.find(item => item.id === step);
        if (stepDetails) {
          this.selectBookings(stepDetails);
        }
        /*dispatch(setPendingBooking({}, false));
        dispatch(pendingBooking({}));*/
      } else {
        const stepDetails = this.state.steps.find(item => item.id === step);
        if (stepDetails) {
          this.selectBookings(stepDetails);
        }
      }
    } else {
      if (this.props.userId) {
        this.fetchBookings([BOOKING_STATUS.PENDING,BOOKING_STATUS.ACCEPTED]);
      }
    }
  };

  componentDidMount() {
    this.fetchDetailsOnLoad();
  }

  selectBookings = item => {
    this.fetchBookings(item.status);
    this.setState({ step: item.id });

    this.props.history.push("?step=" + item.id);

    if (item.id === 1) {
      this.setState({ bookingDrawer: false })
    }
  };

  onViewDetails = booking => {
    const { dispatch } = this.props;
    dispatch(setCurrentBooking(booking));
    this.props.history.push("/home/diner-booking-status");
  };

  onReview = (booking) => {
      this.props.history.push("/home/review",{booking});
  };

  onComplete= (booking) => {
      const { updateBooking } = this.props;
      this.setState({ loading: true });
      let payload={
          bookingId:booking.id,
          status:"COMPLETED_BY_USER"
      };

      updateBooking({
          variables: payload
      })
          .then(res => {
              this.setState({ loading: false }, () => {
              });
          })
          .catch(err => {
              console.log(JSON.parse(JSON.stringify(err)));
          });
  };

  onContinue = booking => {
    const { dispatch } = this.props;
    if (booking.isRecurring) this.setState({ isRecurring: true });
    if (booking.isCustom) this.setState({ isCustom: true });
    dispatch(CreateInProgressBooking(booking.id));
    dispatch(SelectedChefDetails(booking.chefId));
    dispatch(selectedChef(booking.chefId));
    dispatch(SelectedChefAvailability(booking.chefId, moment(booking.date).format('YYYY-MM-DD')));
    dispatch(setSelectedDate(moment(booking.date).format('YYYY-MM-DD')));
    dispatch(setExBooking(booking, false));
    dispatch(setSelectedSlot({
      start: booking.timeSlot.start,
      end: booking.timeSlot.end,
    }));
    if (booking.isCustom) {
      dispatch(setCustomPriceange({
        startPrice: booking.startPrice,
        endPrice: booking.endPrice,
        dinerSize: booking.dinerSize,
      }))
    }
    const cart = [];
    let dishesList = [];
    client.query({
      query: DISHES_BY_CHEF,
      variables: {
        chefId: booking.chefId,
        live: true,
        pageSize: 100
      }
    })
      .then(dishResp => {
        const {data: {dishesByChef}} = dishResp;

        if (!!dishesByChef && !!dishesByChef.dishes && dishesByChef.dishes.length) {
          dishesList = dishesByChef.dishes;
        }

        dishesList.forEach(dish => {
          const index = booking.dishes.findIndex(item => item.dishId === dish.id);
          if (index > -1) {
            const bookingDish = booking.dishes[index];

            cart.push({
              id: dish.id,
              name: dish.name,
              serves: bookingDish.serves,
              minPrice: dish.minPrice,
              minDinerSize: dish.minDinerSize
            });
          }
        });
        dispatch(updateCart(cart));
      })
      .catch(err => { console.log('ERROR Fetching dishes by Chef', err);});

    this.toggleBookingDrawer();
  };

  toggleBookingDrawer = () => {
    this.setState({
      bookingDrawer: !this.state.bookingDrawer
    }, () => {
      if (!this.state.bookingDrawer) {
        this.fetchDetailsOnLoad();
        this.setState({ isRecurring: false, isCustom: false });
      }
    });
  };

  closeBookingDrawer = () => {
    this.setState({
      bookingDrawer: false
    });
    this.fetchDetailsOnLoad();
  };

  render() {
    const { steps, bookings, step } = this.state;
    const { location } = this.props;
    let closeSlider = undefined;
    const parsed = QueryString.parse(location.search);
    // let step = 1;
    if (parsed) {
      // step = parsed.step ? parseInt(parsed.step) : 1;

      if (parsed.closeSlider) {
        closeSlider = "yes";
      }
    }

    if (step == 1) {
      bookings.sort((a, b) => { return a.date - b.date });
    } else {
      bookings.sort((a, b) => { return b.date - a.date });
    }

    return (
      <Grid container justify={"center"}>
        <Grid item xs={12}>
          <Header history={this.props.history} />
          {this.state.loading && <LinearProgress />}
        </Grid>
        <div className="dish-container-custom">
          <Grid className="booking-heading-col" container>
            <Grid item xs={12} style={{ marginBottom: 15 }}>
              <Breadcrumbs childRoutes={[
                {
                  display: 'Bookings',
                  link: 'home/diner-bookings'
                },
              ]} />
            </Grid>
            <Grid item xs={12}>
              <p style={style.headerText}>Bookings</p>
            </Grid>
          </Grid>
          <Grid container className="booking-content-col">
          <Grid item className="booking-sidebar">
            <List>
              {steps.map(item => (
                <ListItem
                  key={item.id}
                  button
                  onClick={() => this.selectBookings(item)}
                  style={{ ...style.itemStyle, ...style.textFont }}
                >
                  <div
                    onMouseOver={() => this.setStepIdHover(item.id)}
                    onMouseLeave={() => this.setStepIdHover(0)}
                  >
                    <p
                      style={
                        step === item.id || this.state.stepIdHover === item.id
                          ? style.stepSelected
                          : style.stepUnselected
                      }
                    >
                      {item.text}
                    </p>
                  </div>
                </ListItem>
              ))}
            </List>
          </Grid>
          <div className="bookings-gap-left" />
          <Grid item sm={8} md={9} lg={8}>
            {(bookings.length === 0 && !this.state.loading)&&
            <Grid container justify={'center'} xs={8} lg={8}>
              <Typography
                variant="h5"
                style={{  fontFamily: webFont,
                  color: textBlack,
                  weight: 800,
                  marginBottom: 30,
                  marginTop: 30 }}
              >No bookings found</Typography>
            </Grid>}
            <BookingList>
              {!!bookings.length &&
                bookings.map(booking => (
                  <BookingCard
                    key={booking.id + "booking"}
                    booking={booking}
                    onReview={() => this.onReview(booking)}
                    onViewDetails={() => this.onViewDetails(booking)}
                    onContinue={()=>this.onContinue(booking)}
                    onComplete={()=>this.onComplete(booking)}
                    fetchAgain={()=>this.fetchDetailsOnLoad()}
                    userId={this.props.userId}
                  />
                ))}
            </BookingList>
              <InProgressBooking
                  toggleBookingDrawer={!!closeSlider && closeSlider === "yes" ? false : this.state.bookingDrawer }
                  closeBookingDrawer={this.closeBookingDrawer}
                  style={{ zIndex: 9999, position: "relative" }}
                  handleToggle={this.toggleBookingDrawer}
                  history={this.props.history}
                  parentPage={'bookings'}
                  isRecurring={this.state.isRecurring}
                  isCustom={this.state.isCustom}
              />
          </Grid>
        </Grid>
        </div>
      </Grid>

    );
  }
}
const style = {
  headerText: {
    fontSize: "26px",
    fontFamily: webFont,
    fontWeight: 500,
    margin: 0,
  },
  itemStyle: {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    padding: 0,
    borderBottom: "1px solid lightgray"
  },
  stepNumber: {
    opacity: 0.4,
    fontSize: 14,
    color: textPrimary,
    fontFamily: webFont
  },
  stepText: {
    fontSize: 17,
    fontWeight: 500,
    color: primaryColor,
    fontFamily: webFont
  },
  stepSelected: {
    fontSize: 20,
    fontWeight: 500,
    color: "#ff8000",
    fontFamily: webFont,
    margin: '19px 0',
  },
  stepNumberUnselected: {
    opacity: 0.12,
    fontSize: 14,
    color: "#000000",
    fontFamily: webFont
  },
  stepUnselected: {
    fontSize: 20,
    fontWeight: 500,
    color: "#000000",
    fontFamily: webFont,
    margin: '19px 0',
    '&:hover': {
      color: "#ff8000",
    }
  },
  textFont: {
    fontFamily: webFont
  },
  nextButton: {
    width: 204,
    height: 49,
    borderRadius: "45.5px",
    fontSize: 18,
    color: "white",
    textTransform: "none",
    fontFamily: webFont
  }
};
const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef
  };
};

const BookingWithData = compose(
    graphql(UPDATE_BOOKING, {
        name: "updateBooking"
    })
)(Bookings);
const DinerBookings = connect(mapStateToProps)(BookingWithData);
export default DinerBookings;
